import React from 'react'
import ResearchHelpContentSkeleton from './ResearchHelpContentSkeleton'

export default function ResearchHelpTabsSkeleton(): JSX.Element {
  return <ResearchHelpContentSkeleton />
}
